module.exports = __webpack_public_path__ + "img/ic_navigation.3388b539.svg";